<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">{{ $yuyanbao.xiangqing }}</h1>
        </div>
      </div>
      <nav class="breadcrumb-nav">
        <div class="container">
          <ul class="breadcrumb bb-no">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              <router-link to="/boke">{{ $yuyanbao.boke }}</router-link>
            </li>
            <li>{{ $yuyanbao.xiangqing }}</li>
          </ul>
        </div>
      </nav>
      <div class="page-content mb-8">
        <div class="container">
          <div class="row gutter-lg">
            <div class="post-single-content">
              <div class="post post-grid post-single">
                <figure class="post-media br-sm">
                  <el-carousel :interval="5000" arrow="hover" :height="$store.state.width <= 1000
                    ? '300px'
                    : $store.state.width <= 1400
                      ? '467px'
                      : '538px'">
                    <el-carousel-item v-for="(item, index) in boke.tupian" :key="index">
                      <figure class="shangpin-image">
                        <el-image :src="item" :preview-src-list="boke.tupian" fit="cover" :style="{
                          height: $store.state.width <= 1000
                            ? '300px'
                            : $store.state.width <= 1400
                              ? '467px'
                              : '538px',
                          width: '100%',
                        }"></el-image>
                      </figure>
                    </el-carousel-item>
                  </el-carousel>
                </figure>
                <div class="post-details">
                  <div class="post-meta">
                    <span class="post-author">
                      {{ $shezhi.title1 }}
                    </span>
                    -
                    <span class="post-date">
                      {{ format_date(boke.created) }}
                    </span>
                  </div>
                  <h2 class="post-title">
                    {{ duoyuyan(boke) }}
                  </h2>
                  <div class="post-content">
                    <p v-html="duoyuyan(boke, 'miaoshu')"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Waterfall :options="options" style="margin: 30px 20px">
            <WaterfallItem v-for="(src, index) in boke.tupian" :key="index" class="waterfallitem">
              <el-image class="itemimage" v-if="boke.tupian.length > 0" :src="src"
                :preview-src-list="boke.tupian"></el-image>
            </WaterfallItem>
          </Waterfall>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import { Waterfall, WaterfallItem } from "vue2-waterfall";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import { getJiHe } from "@/api/jihe";

export default {
  name: "BlogDetail",
  components: {
    Waterfall,
    WaterfallItem,
    elImageViewer,
  },
  data () {
    return {
      ukey: "",
      boke: {},
      loading: false,
      options: {},
    };
  },
  mounted () {
    this.ukey = this.$route.query.ukey;
    this.get_boke_http();
  },
  methods: {
    get_boke_http () {
      this.loading = true;
      getJiHe({ ukey: this.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") this.boke = data.data;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.waterfallitem {
  margin-bottom: 10px;
}

.waterfallitem .itemimage {
  border-radius: 10px;
  display: block;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 0 10px 2px rgba(151, 151, 151, 0.1);
}

@media (max-width: 768px) {
  .waterfallitem {
    width: 50%;
  }

  .waterfallitem:nth-child(2n) {
    padding-left: 5px;
  }

  .waterfallitem:nth-child(2n + 1) {
    padding-right: 5px;
  }
}

@media (max-width: 992px) {
  .waterfallitem {
    width: 33%;
  }

  .waterfallitem:nth-child(3n) {
    padding-left: 5px;
  }

  .waterfallitem:nth-child(3n + 1) {
    padding-right: 5px;
  }

  .waterfallitem:nth-child(3n + 2) {
    padding: 0 2.5px;
  }
}

@media (min-width: 993px) {
  .waterfallitem {
    width: 25%;
  }

  .waterfallitem:nth-child(4n) {
    padding-left: 5px;
  }

  .waterfallitem:nth-child(4n + 1) {
    padding-right: 5px;
  }

  .waterfallitem:nth-child(4n + 2) {
    padding: 0 5px;
  }

  .waterfallitem:nth-child(4n + 3) {
    padding: 0 5px;
  }
}
</style>